// extracted by mini-css-extract-plugin
export default {"backButtonWrapper":"GoBackButton_backButtonWrapper__bKZkp","backButton":"GoBackButton_backButton__p+8FA","text":"GoBackButton_text__O0VN1"};